import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import clsx from 'clsx';
import Image from 'next/image';
import Link from 'next/link';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ListsCard = _ref => {
  let {
    onClick,
    href,
    imgSrc,
    title,
    description,
    className
  } = _ref;

  const body = /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("span", {
      className: styles.image,
      children: /*#__PURE__*/_jsx(Image, {
        src: imgSrc,
        width: 74,
        height: 76,
        alt: "guide button icon"
      })
    }), /*#__PURE__*/_jsx("span", {
      className: styles.action,
      children: title
    }), /*#__PURE__*/_jsx("span", {
      className: styles.actionDescription,
      children: description
    })]
  });

  if (href) {
    return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
      href: href,
      className: clsx(styles.card, className)
    }, onClick ? {
      onClick
    } : {}), {}, {
      children: body
    }));
  }

  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    type: "button",
    className: clsx(styles.card, className)
  }, onClick ? {
    onClick
  } : {}), {}, {
    children: body
  }));
};

export default ListsCard;